/** Default platform API base URL (production VPS) */
export const DEFAULT_PLATFORM_API_URL = 'https://compliance-command-api.keyteller.com';

/** sessionStorage key for active platform session id */
export const SESSION_STORAGE_KEY = 'compliance_command_platform_session_id';

/** Stable anonymous learner id for analytics (localStorage) */
export const PLAYER_REF_STORAGE_KEY = 'compliance_command_player_ref';

/** sessionStorage flag indicating a checkpoint exists on the server */
export const SESSION_CHECKPOINT_FLAG_KEY = 'compliance_command_platform_has_checkpoint';

/** Resolve API base URL, trimming trailing slashes */
export function resolvePlatformApiUrl(envValue?: string): string {
  if (typeof envValue === 'string' && envValue.trim()) {
    return envValue.trim().replace(/\/+$/, '');
  }
  return DEFAULT_PLATFORM_API_URL;
}

/**
 * Platform API URL for client adapters.
 * Set `VITE_PLATFORM_API_URL` at build time; falls back to production VPS URL.
 */
export function getPlatformApiUrl(): string {
  const viteUrl =
    typeof import.meta !== 'undefined' && import.meta.env
      ? import.meta.env.VITE_PLATFORM_API_URL
      : undefined;
  return resolvePlatformApiUrl(viteUrl);
}

/** Resolved at module load — used as default constructor arg in HTTP adapters */
export const PLATFORM_API_URL = getPlatformApiUrl();